import { numberFormat } from 'shared/utils/formatter';
import { hasLicenseLimit } from 'shared/utils/license';

const LicenseLimit = ({ limit }) => {
  if (!hasLicenseLimit(limit)) {
    return 'Unlimited';
  }

  return numberFormat(limit);
};

export default LicenseLimit;
